import { render, staticRenderFns } from "./MasterBatanganEdit.vue?vue&type=template&id=7be9b32e&scoped=true"
import script from "./MasterBatanganEdit.vue?vue&type=script&lang=js"
export * from "./MasterBatanganEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be9b32e",
  null
  
)

export default component.exports